// The VPS collections use Chinese field names while the pages were written
// against the old Firestore camelCase shape. These adapters translate between
// the two so neither side has to change.

export const API_URL =
  process.env.REACT_APP_API_URL || 'https://multi-counter.bancheng.tech/api';

export const toCompany = (doc) => {
  if (!doc) return null;
  return {
    id: doc._id,
    // The schema has no dedicated code column; the row id doubles as the code.
    companyCode: doc._id,
    companyName: doc.名稱,
    // No isActive column exists, so every stored company counts as active.
    isActive: true,
    webhookUrl: doc.webhookUrl || null,
    settings: {
      allowGlobalAds: doc.廣告 === true,
      soundSettings: doc.soundSettings || null
    },
    createdAt: doc.createdAt,
    updatedAt: doc.updatedAt
  };
};

export const toDevice = (doc) => {
  if (!doc) return null;
  return {
    id: doc._id,
    deviceCode: doc._id,
    deviceName: doc.名稱,
    deviceType: doc.類別 || null,
    companyId: doc.公司ID,
    displayUrl: doc.顯示器連結 || null,
    requiresPassword: Boolean(doc.登入密碼),
    // Only present when the caller asked for ?withTimer=true.
    timerId: doc.timerId !== undefined ? doc.timerId : null,
    isActive: true,
    createdAt: doc.createdAt,
    updatedAt: doc.updatedAt
  };
};

export const toSlideshow = (doc) => {
  if (!doc) return null;
  const isVideo = Boolean(doc.影片);
  const mediaUrl = doc.影片 || doc.圖片 || '';
  return {
    id: doc._id,
    companyId: doc.公司ID,
    mediaUrl,
    mediaType: isVideo ? 'video' : 'image',
    // No title column exists; fall back to the file name so lists stay readable.
    title: mediaUrl ? decodeURIComponent(mediaUrl.split('/').pop().split('?')[0]) : '',
    duration: doc.圖片秒數 ?? 5,
    order: doc.順序 ?? 0,
    isDisabled: doc.停用 === true,
    // Not modelled on the VPS side; kept so existing UI bindings resolve.
    isAd: false,
    managedBy: doc.來源 === 'api' ? 'api' : 'google-sheets',
    createdAt: doc.createdAt,
    updatedAt: doc.updatedAt
  };
};

export const fromSlideshow = (data = {}) => {
  const payload = {};
  if (data.companyId !== undefined) payload.公司ID = data.companyId;
  if (data.duration !== undefined) payload.圖片秒數 = data.duration;
  if (data.order !== undefined) payload.順序 = data.order;
  if (data.isDisabled !== undefined) payload.停用 = data.isDisabled;
  if (data.mediaUrl !== undefined) {
    if (data.mediaType === 'video') {
      payload.影片 = data.mediaUrl;
      payload.圖片 = null;
    } else {
      payload.圖片 = data.mediaUrl;
      payload.影片 = null;
    }
  }
  return payload;
};

// Pages written for Firestore expect an unsubscribe function. Nothing on the
// VPS side pushes these collections, so poll and hand back a matching teardown.
export const pollingSubscription = (fetcher, callback, intervalMs = 5000) => {
  let cancelled = false;

  const tick = async () => {
    try {
      const data = await fetcher();
      if (!cancelled) callback(data);
    } catch (error) {
      console.error('Subscription poll failed:', error);
    }
  };

  tick();
  const id = setInterval(tick, intervalMs);

  return () => {
    cancelled = true;
    clearInterval(id);
  };
};
